import { useState, Fragment } from 'react';
import { TeamLogo } from './TeamLogo';

// Round-robin standings with PF/PA columns and an expandable per-match score breakdown.
export default function StandingsTable({ rows, matches, logoMap, onLogo, accent = '#E63946' }) {
  const [openTeam, setOpenTeam] = useState(null);
  const teamMatches = (teamId) => (matches || [])
    .filter(m => m.status === 'completed' && (m.team_a_id === teamId || m.team_b_id === teamId))
    .sort((a, b) => a.match_number - b.match_number);
  return (
    <table className="w-full text-sm">
      <thead>
        <tr style={{ color: '#737373', fontSize: 11, textTransform: 'uppercase' }}>
          <th className="text-left px-4 py-2">#</th><th className="text-left px-4 py-2">Team</th>
          <th className="px-3 py-2">Played</th><th className="px-3 py-2">Wins</th><th className="px-3 py-2">Losses</th>
          <th className="px-3 py-2">Pts For</th><th className="px-3 py-2">Pts Against</th><th className="px-3 py-2">Pt. Diff</th><th className="px-2 py-2"></th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => {
          const isOpen = openTeam === row.team_id;
          const tms = isOpen ? teamMatches(row.team_id) : [];
          return (
            <Fragment key={row.team_id}>
              <tr data-testid={`standings-row-${row.team_id}`} onClick={() => setOpenTeam(isOpen ? null : row.team_id)}
                style={{ borderTop: '1px solid #1A1A1A', color: '#fff', cursor: 'pointer' }}>
                <td className="px-4 py-2" style={{ color: i === 0 ? '#22C55E' : '#737373', fontWeight: 700 }}>{i + 1}</td>
                <td className="px-4 py-2 font-semibold">
                  <span className="flex items-center gap-2">
                    <TeamLogo logo={logoMap?.[row.team_id]} name={row.team_name} size={24} onClick={onLogo} />
                    {row.team_name}
                  </span>
                </td>
                <td className="px-3 py-2 text-center tabular-nums">{row.played}</td>
                <td className="px-3 py-2 text-center tabular-nums" style={{ color: '#22C55E' }}>{row.wins}</td>
                <td className="px-3 py-2 text-center tabular-nums" style={{ color: '#E63946' }}>{row.losses}</td>
                <td className="px-3 py-2 text-center tabular-nums" style={{ color: '#A3A3A3' }}>{row.points_for}</td>
                <td className="px-3 py-2 text-center tabular-nums" style={{ color: '#A3A3A3' }}>{row.points_against}</td>
                <td className="px-3 py-2 text-center tabular-nums font-bold" style={{ color: row.diff > 0 ? '#22C55E' : row.diff < 0 ? '#E63946' : '#A3A3A3' }}>{row.diff > 0 ? '+' : ''}{row.diff}</td>
                <td className="px-2 py-2 text-center text-xs" style={{ color: '#525252' }}>{isOpen ? '▲' : '▼'}</td>
              </tr>
              {isOpen && (
                <tr style={{ background: '#0A0A0A' }}>
                  <td colSpan={9} className="px-4 py-2">
                    {tms.length === 0 ? <p className="text-xs" style={{ color: '#525252' }}>No completed matches yet.</p> : (
                      <div className="space-y-1">
                        {tms.map(m => {
                          const isA = m.team_a_id === row.team_id;
                          const opp = isA ? m.team_b_name : m.team_a_name;
                          const won = m.winner_side === (isA ? 'a' : 'b');
                          const sets = (m.games || []).map(g => isA ? `${g.score_a}-${g.score_b}` : `${g.score_b}-${g.score_a}`).join(', ');
                          return (
                            <div key={m.id} className="flex items-center justify-between text-xs" data-testid={`standings-detail-${m.match_number}`}>
                              <span style={{ color: '#A3A3A3' }}>M{m.match_number} vs <span style={{ color: '#fff' }}>{opp || 'TBD'}</span></span>
                              <span className="flex items-center gap-2">
                                <span style={{ color: '#737373' }}>{sets || '—'}</span>
                                <span className="font-bold px-1.5 rounded" style={{ color: won ? '#22C55E' : '#E63946', background: (won ? '#22C55E' : '#E63946') + '18' }}>{won ? 'W' : 'L'}</span>
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </Fragment>
          );
        })}
      </tbody>
    </table>
  );
}
